import ProjectConfigurationViewer from '../project/ProjectConfigurationViewer';
import ProjectApiService from '@lib/api-services/ProjectApiService';
import ConfigurationReadOnlyApiService from '@lib/api-services/ConfigurationReadOnlyApiService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ConfigurationEditPage from '../configuration/ConfigurationEditPage';
import configurationStore from '../../store/configuration';
import Button from '../common/Button';

const ConfigurationViewPage = class ConfigurationViewPage extends ConfigurationEditPage {
    configurationEditorComponentClass = ProjectConfigurationViewer

    constructor(props) {
        super(props)
        configurationStore.editableMode = false;
        scheduleAtDocumentReady(() => {
            this.projectAPIService = APIServicesRegistry.getService(ProjectApiService)
            this.configurationReadOnlyApiService = APIServicesRegistry.getService(ConfigurationReadOnlyApiService)
            this.setState({_forceUpdate: !this.state._forceUpdate});
        })
    }

    save() {
    }


    getDocumentationApi() {
        return this.configurationReadOnlyApiService;
    }

    getDesktopActionButtons() {
        return <Button key={1} onClick={() => this.onCopyButtonClick()}>{__('Copy')}</Button>
    }
}

window.components.ConfigurationViewPage = ConfigurationViewPage
